import { createRouter, createWebHistory } from "vue-router";

import { admin_routes } from "./admin";
import { web_routes } from "./web";

const routes = [...admin_routes, ...web_routes];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

// ✅ Set Title BEFORE route loads (better UX)
router.beforeEach((to, from, next) => {
  const baseTitle = "Family Group BimaGrow";

  const pageTitle = to.meta?.title
    ? `${to.meta.title} | ${baseTitle}`
    : baseTitle;

  document.title = pageTitle;

  next();
});

// ✅ Google Analytics Tracking (SPA FIX)
router.afterEach((to) => {
  const baseTitle = "Family Group BimaGrow";

  const pageTitle = to.meta?.title
    ? `${to.meta.title} | ${baseTitle}`
    : baseTitle;

  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_title: pageTitle,
      page_path: to.fullPath,
      page_location: window.location.href,
    });
  }
});
